import { useCustomMutation } from '../../graphql';

export const useAssignFeatureToAccounts = () => {
  return useCustomMutation({ query: ASSIGN_FEATURE_TO_ACCOUNTS });
};

export const ASSIGN_FEATURE_TO_ACCOUNTS = `
  mutation AssignFeatureToAccounts($input: AssignFeatureToAccountsInput!) {
    feature {
      assignFeatureToAccounts(input: $input) {
        success
        message
      }
    }
  }
`;
